<template>
<div>

    
    <el-dialog width="80%" title="答题卡历史比对" :visible.sync="dialogVisible" :close-on-click-modal="false" >
        <div>
        <el-form :model="form"  label-width="120px" style="margin-bottom: 20px;">
            <el-form-item label="历史版本：" prop="batchId">
                <el-select v-model="form.batchId" placeholder="请选择" @change="checkAnswerByBatchId">
                    <el-option
                    v-for="(item,index) in batchList"
                    :key="item.batchId"
                    :label="'历史版本' + (index +1) + '(' + item.date +')'"
                    :value="item.batchId">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        </div>
        
        <div>
            <div>
                <span style="font-size: 14px;color: #4D4D4D;">本试卷共有{{newExamTopicForm.kgCount+newExamTopicForm.zgCount}}道题目:
                    客观题{{newExamTopicForm.kgCount}}道，共{{newExamTopicForm.kgScore}}分、
                    主观题{{newExamTopicForm.zgCount}}道，共{{newExamTopicForm.zgScore}}分，
                    总分值
                    <span style="color: red;">{{parseFloat(newExamTopicForm.kgScore)+parseFloat(newExamTopicForm.zgScore)}}</span>
                    分</span>
            </div>
            <el-tabs v-model="activeName" @tab-click="tabClick">
                <el-tab-pane label="客观题设置" name="kg">
                    <!-- <el-form :inline="true" :model='kgForm' :rules="kgFormRules" ref="kgForm" @submit.native.prevent class="demo-form-inline search-form">
                        <el-form-item label="起始序号"  prop="startIndex">
                            <el-select v-model="kgForm.startIndex" filterable placeholder="请选择" style="width: 100px;">
                                <el-option v-for="item in kgIndexList" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="结束序号" prop="endIndex">
                            <el-select v-model="kgForm.endIndex" filterable placeholder="请选择" style="width: 100px;">
                                <el-option v-for="item in kgIndexList" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="每题分数" prop="score">
                            <el-input v-model="kgForm.score" placeholder="分数" style="width: 100px;"></el-input>
                        </el-form-item>
                        <el-form-item :label="isAb?'A卷答案':'答案(非必填)'">
                            <el-tooltip class="item" effect="dark" content="格式：A,B,AB,或T,T,F,F，每题英文逗号隔开" placement="top">
                                <el-input v-model="kgForm.answer" placeholder="每题英文逗号隔开，格式：A,B,AB,或T,T,F,F，"></el-input>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item v-if="isAb" label="B卷答案">
                          <el-tooltip class="item" effect="dark" content="格式：A,B,AB,或T,T,F,F，每题英文逗号隔开" placement="top">
                            <el-input v-model="kgForm.answerB" placeholder="每题英文逗号隔开，格式：A,B,AB,或T,T,F,F，"></el-input>
                          </el-tooltip>
                        </el-form-item>
                        <el-form-item >
                          <el-button type="text" size="mini" @click="kgFromSubmit">设置</el-button>
                        </el-form-item>
                    </el-form> -->
                    <!-- <el-table v-loading="loading" :data="kgData" style="width: 100%" height="400" :span-method="spanMethod" align='center'> -->
                    <el-table v-loading="loading" :data="filteredKgDataData" style="width: 100%" height="400" :span-method="spanMethod" align='center'>
                        <el-table-column prop="topic_index" label="系统号" min-width="30" align='center' ></el-table-column>
                        <el-table-column prop="topic_no" label="题号"  min-width="30" align='center' ></el-table-column>
                        <el-table-column prop="topic_type" label="题型"  min-width="50" align='center' :formatter="formatterTopicType"></el-table-column>
                        <el-table-column prop="remark" label="备注"  width="120" align='center' >
                          <!-- <template slot-scope='{row}'>
                            <el-input v-model="row.remark" style="width: 100px;"></el-input>
                          </template> -->
                        </el-table-column>
                        <!-- <el-table-column label="变更" max-width="80" align='center'  >
                            <template slot-scope='scope'>
                                <el-button type="text" size="mini" v-if="scope.row.topic_type =='SingleChoice'" @click="changeType(scope.row)">改为多选题</el-button>
                                <el-button type="text" size="mini" v-if="scope.row.topic_type =='MultiChoice'" @click="changeType(scope.row)">改为单选题</el-button>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="score_count" :label="isAb?'A卷选项':'选项'"  :width="kgWidth" align='center' >
                            <template slot-scope='scope'>
                                <!-- {{ scope.row.answer }} -->
                                <span v-for="c in scope.row.answer"> {{ c }}</span>
                                <!-- <el-radio-group v-model="scope.row.answer" size="small" v-if="scope.row.topic_type =='SingleChoice'">
                                    <el-radio-button :label="getChooose(scope.row.topic_type, c)" v-for=" c in scope.row.option_count" style="margin-left: 4px;"></el-radio-button>
                                </el-radio-group>
                                <el-checkbox-group v-model="scope.row.answer" size="small" v-if="scope.row.topic_type =='MultiChoice'">
                                    <el-checkbox-button :label="c" v-for="c in turnChoooses(scope.row.option_count)" :key="c" style="margin-left: 4px;"></el-checkbox-button>
                                </el-checkbox-group>
                                <el-radio-group v-model="scope.row.answer" size="small" v-if="scope.row.topic_type =='Judge'">
                                    <el-radio-button :label="getChooose(scope.row.topic_type, c)" v-for=" c in scope.row.option_count" style="margin-left: 8px;"></el-radio-button>
                                </el-radio-group> -->
                            </template>
                        </el-table-column>
                        <el-table-column prop="topic_no" label="多选规则"  min-width="50" align='center' >
                            <template slot-scope='scope'>
                                <el-button type="text" size="mini" v-if="scope.row.topic_type =='MultiChoice'"
                                           :style="scope.row.score_rules!=null?{color: 'red'}:null"
                                           @click="specialMark(scope.row)">特殊规则</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="score_count" v-if="isAb" label="B卷选项" :width="kgWidth" align='center' >
                            <template slot-scope='scope'>
                                <el-radio-group v-model="scope.row.answer_b" size="small" v-if="scope.row.topic_type =='SingleChoice'">
                                    <el-radio-button :label="getChooose(scope.row.topic_type, c)" v-for=" c in scope.row.option_count" style="margin-left: 4px;"></el-radio-button>
                                </el-radio-group>
                                <el-checkbox-group v-model="scope.row.answer_b" size="small" v-if="scope.row.topic_type =='MultiChoice'">
                                    <el-checkbox-button :label="c" v-for=" c in turnChoooses(scope.row.option_count)" :key="c" style="margin-left: 4px;"></el-checkbox-button>
                                </el-checkbox-group>
                                <el-radio-group v-model="scope.row.answer_b" size="small" v-if="scope.row.topic_type =='Judge'">
                                    <el-radio-button :label="getChooose(scope.row.topic_type, c)" v-for=" c in scope.row.option_count" style="margin-left: 8px;"></el-radio-button>
                                </el-radio-group>
                            </template>
                        </el-table-column>
                        <el-table-column prop="score" min-width="100" label="分数" align='center' >
                            <!-- <template slot-scope='scope'>
                                <el-input v-model="scope.row.score" v-if="'batchSet' in scope.row" placeholder="设置分数" @blur="batchScore(scope.row.topic_type, scope.row.score)" style="width: 100px;"></el-input>
                                <el-input v-model="scope.row.score" v-else placeholder="设置分数" @blur="calcCount" style="width: 100px;"></el-input>
                            </template> -->
                        </el-table-column>

                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="主观题设置" name="zg">
                    <!-- <el-form :inline="true" :model='zgForm' ref="searchForm" @submit.native.prevent class="demo-form-inline search-form">
                        <el-form-item label="批量设置分数">
                            <el-input v-model="zgForm.score" placeholder="分数" @blur="changeScore(2)"  @keyup.enter.native='changeScore(2)'></el-input>
                        </el-form-item>
                    </el-form> -->
                    <!-- <el-table v-loading="loading" :data="zgData" style="width: 100%" height="400" align='center'> -->
                    <el-table v-loading="loading" :data="filteredZgDataData" style="width: 100%" height="400" align='center'>
                        <el-table-column prop="topic_index" label="系统号" min-width="30" align='center' ></el-table-column>
                        <el-table-column prop="topic_no" label="题号"  min-width="30" align='center' ></el-table-column>
                        <el-table-column prop="remark" label="备注"  width="120" align='center' >
                          <!-- <template slot-scope='{row}'>
                            <el-input v-model="row.remark" style="width: 100px;"></el-input>
                          </template> -->
                        </el-table-column>
                        <el-table-column prop="topic_type" label="题型" min-width="80" align='center' :formatter="formatterTopicType" ></el-table-column>
                        <el-table-column prop="score" min-width="80" label="分数" align='center' >
                            <!-- <template slot-scope='scope'>
                                <el-input v-model="scope.row.score" placeholder="设置分数" @blur="calcCount" style="width: 80px;"></el-input>
                            </template> -->
                        </el-table-column>

                    </el-table>
                </el-tab-pane>

            </el-tabs>

        </div>


        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button @click="saveHistory" type="primary">使 用</el-button>
        </div>

    </el-dialog>

    <topicSpecialDialog ref="topicSpecialDialog" :topicSpecial="selTopic" @ok="setScoreRule"></topicSpecialDialog>
</div>
</template>
<script>
import {mapGetters, mapState} from "vuex";
import * as simpleApi from "request/simple";
import XEUtils from 'xe-utils'
import * as mUtils from '@/utils/mUtils'
import topicSpecialDialog from "./topicSpecialDialog";

export default {
    name: 'answerHistory',
        data(){
            return {
                // 窗口显隐
                dialogVisible: false,
                examId: null,
                batchList:[],
                form: {batchId: null},
                activeName:'kg',
                kgData: [], 
                zgData: [], 
                kgIndexList: [],
                isAb: false, 
                selTopic: null, 
                state: 0,
                kgForm: { 
                    startIndex: null, 
                    endIndex: null, 
                    score: null, 
                    answer: null, 
                    answerB: null
                },
                zgForm: {
                    score: null,
                },
                examSheetForm: {
                    examId: null, 
                    sheetId: null, 
                    sheetName: null
                },
                newExamTopicForm: { 
                    examId: null, 
                    sheetId: null, 
                    kgCount: 0, 
                    zgCount: 0, 
                    kgScore: 0, 
                    zgScore: 0, 
                },
                kgFormRules: {
                    startIndex: [{ required: true, message: '请选择开始序号', trigger: 'blur' }],
                    endIndex: [{ required: true, message: '请选择结束序号', trigger: 'blur' }],
                    score: [{ required: true, message: '请输入分数', trigger: 'blur' }],
                },
                versionStatus: true,
                selTopic: null,
            }
        },
        components:{
            topicSpecialDialog
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),
            filteredKgDataData() {
                return this.kgData.filter(item => item.show !== false)
            },
            filteredZgDataData() {
                return this.zgData.filter(item => item.show !== false)
            }
        },
      	mounted() {
	    },
        created() {
        },
        props: {
        },
        watch: {

        },
        methods: {
            loadingTable(){
                let paramData = {examId: this.examId};
                let param = { controllerName: 'akExamTopic', methodName: '/selectHistoryList', param: paramData};

                simpleApi.post(param).then(({result: {code, data}}) =>  {
                    if (code == 0) {
                        this.dialogVisible = true;
                        this.batchList = data
                    }
                    // this.loading = false;
                })

            },
            checkAnswerByBatchId(){
                debugger
                let batchId = this.form.batchId
                let search = { examId: this.examId, batchId: batchId};
                let param = { controllerName: 'akExamTopic', methodName: '/checkAnswerByBatchId', param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    // 判断点击的历史版本是否与现在绑定的版本一致
                    if(!data) {
                        this.versionStatus = false
                        this.$message({ message: '历史版本题数题类与当前选中的答题卡不一致',  type: 'warning' });
                        // 清空当前数据
                        this.newExamTopicForm.kgCount = 0;
                        this.newExamTopicForm.kgScore = 0
                        this.newExamTopicForm.zgCount = 0
                        this.newExamTopicForm.zgScore = 0
                        this.kgData = []
                        this.zgData = []
                        return
                    }
                    this.versionStatus = true
                    this.getAnswerByBatchId()
                })
            },
            getAnswerByBatchId(){
                
                let batchId = this.form.batchId
                let search = { examId: this.examId, batchId: batchId};
                let param = { controllerName: 'akExamTopic', methodName: '/selectHistoryTopicByBatchId', param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    let maxAnwCount = 4;
                    if (code == 0) {
                        let list = data;
                        let kgCount=0, zgCount=0, kgScore=0, zgScore = 0;
                        let kgList = [], zgList = [], sList = [], mList = [], jList = [];
                        for (let i=0; i<list.length; i++){
                            let d = list[i];
                            if(d.topic_type2 == 'Object'){
                                debugger
                                kgCount = kgCount + 1;
                                kgScore = kgScore+((d.score!=null)?parseFloat(d.score): 0);
                                // if(d.topic_type == 'SingleChoice') sList.push(d);
                                if(d.topic_type == 'MultiChoice'){
                                    if(d.answer==null) d.answer = []; else d.answer = d.answer.split(',');
                                    if(this.isAb) {
                                        if(d.answer_b==null) d.answer_b = []; else d.answer_b = d.answer_b.split(',');
                                    }
                                    // mList.push(d);
                                    kgList.push(d);
                                }
                                // if(d.topic_type == 'Judge') jList.push(d);
                                kgList.push(d)
                                this.kgIndexList.push(d.topic_index);
                                if(d.option_count > maxAnwCount) maxAnwCount = d.option_count;
                            }else{
                                zgCount = zgCount + 1;
                                zgScore = zgScore+((d.score!=null)?parseFloat(d.score): 0);
                                zgList.push(d);
                            }
                        }
                        let sdList = [], mdList = [], jdList = [];
                        // if(sList.length > 0) sdList = [{batchSet: 'Y', topic_index: '单选题 - 可在该栏分值输入框内，为以下单选题型的所有题目批量设置统一分值', topic_type: 'SingleChoice', score: null, remark: null,show: false}]
                        // if(mList.length > 0) mdList = [{batchSet: 'Y', topic_index: '多选题 - 可在该栏分值输入框内，为以下多选题型的所有题目批量设置统一分值', topic_type: 'MultiChoice', score: null, remark: null,show: false}]
                        // if(jList.length > 0) jdList = [{batchSet: 'Y', topic_index: '判断题 - 可在该栏分值输入框内，为以下判断题型的所有题目批量设置统一分值', topic_type: 'Judge', score: null, remark: null,show: false}]
                        // kgList = [...sdList, ...sList, ...mdList, ...mList, ...jdList, ...jList];
                        console.log("calcCount", kgCount, zgCount, kgScore, zgScore);
                        this.newExamTopicForm.kgCount = kgCount;
                        this.newExamTopicForm.kgScore = kgScore.toFixed(1);
                        this.newExamTopicForm.zgCount = zgCount;
                        this.newExamTopicForm.zgScore = zgScore.toFixed(1);
                        this.kgData = kgList;
                        this.zgData = zgList;
                        this.kgWidth = maxAnwCount * 60;
                    }
                })
            },
            // 保存答案
            saveHistory(){
                // this.$emit.saveHistory(this.newExamTopicForm.kgCount,this.newExamTopicForm.kgScore,this.newExamTopicForm.zgCount,this.newExamTopicForm.zgScore,this.kgData,this.zgData,this.kgWidth)
                this.$emit("saveHistory",this.versionStatus, this.newExamTopicForm.kgCount,this.newExamTopicForm.kgScore,this.newExamTopicForm.zgCount,this.newExamTopicForm.zgScore,this.kgData,this.zgData,this.kgWidth)
                
                this.$nextTick(() => {
                    this.cancel()
                })
            },
            turnChoooses(cou){
                let myList = [];
                for (let i=0; i<cou; i++){
                    let c = '';
                    if(i==0) c = "A";
                    if(i==1) c = "B";
                    if(i==2) c = "C";
                    if(i==3) c = "D";
                    if(i==4) c = "E";
                    if(i==5) c = "F";
                    if(i==6) c = "G";
                    if(i==7) c = "H";
                    if(i==8) c = "I";
                    if(i==9) c = "J";
                    if(i==10) c = "K";
                    if(i==11) c = "L";
                    if(i==12) c = "M";
                    if(i==13) c = "N";
                    if(i==14) c = "O";
                    if(i==15) c = "P";
                    if(i==16) c = "Q";
                    myList.push(c);
                }
                return myList;
            },
            getChooose(t, c){
                let i = c-1;
                if(t == 'SingleChoice' || t == 'MultiChoice'){
                    if(i==0) return "A";
                    if(i==1) return "B";
                    if(i==2) return "C";
                    if(i==3) return "D";
                    if(i==4) return "E";
                    if(i==5) return "F";
                    if(i==6) return "G";
                    if(i==7) return "H";
                    if(i==8) return "I";
                    if(i==9) return "J";
                    if(i==10) return "K";
                    if(i==11) return "L";
                    if(i==12) return "M";
                    if(i==13) return "N";
                    if(i==14) return "O";
                    if(i==15) return "P";
                    if(i==16) return "Q";
                }
                if(t == 'Judge') {
                    if (i == 0) return "T";
                    if (i == 1) return "F";
                }
            },
            formatterTopicType(row, column, cellValue, index) {
                if(cellValue == 'Object') return '客观题';
                if(cellValue == 'SingleChoice') return '单选题';
                if(cellValue == 'MultiChoice') return '多选题';
                if(cellValue == 'Judge') return '判断题';
                if(cellValue == 'FillBlank') return '填空题';
                if(cellValue == 'Subjective') return '主观题';
                if(cellValue == 'AnswerQuestion') return '解答题';
                if(cellValue == 'Composition') return '语文作文题';
                if(cellValue == 'CNComposition') return '语文作文题';
                if(cellValue == 'EnglishComposition') return '英语作文题';
                return cellValue;
            },
            cancel(){
                // 清空
                this.newExamTopicForm.kgCount = 0
                this.newExamTopicForm.kgScore = 0
                this.newExamTopicForm.zgCount = 0
                this.newExamTopicForm.zgScore = 0
                this.kgData = []
                this.zgData = []
                this.form.batchId = null  
                this.dialogVisible = false

            },
            specialMark(row){
                this.selTopic = row;
                this.$refs.topicSpecialDialog.showDialog(1);
            },
        }


}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
.el-form-item {  
    display: flex; /* 或者使用 inline-flex */  
    align-items: center; /* 垂直居中对齐 */  
}  
.el-form-item__label {  
    margin-right: 10px; /* 调整右边距以缩小距离 */  
}  

.left-col {
  position: relative;
  padding-right: 20px; /* 为竖线留出空间 */
}

.left-col::after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #dcdfe6; /* 竖线颜色 */
}

.right-col {
  padding-left: 20px; /* 与左侧对称 */
}
</style>
